// src/components/KozelBattle/Prefer.tsx
import React from "react";
import { Box, Typography } from "@mui/material";
import usePreferStyles from '../../styles/kozelBattle/prefer';
import copite from '../../assets/images/bicycle_game/ecran2_copite.png';
import tapMic from '../../assets/images/kozel_battle/tap_mic.png';

const Prefer: React.FC = () => {
  const classes = usePreferStyles();

  return (
      <Box className={classes.content}>       

        {/* Poza tap_mic */}
        <img
          src={tapMic}
          alt="Tap Mic"
          className={classes.tapMicImage}
        />
      </Box>
  );
};

export default Prefer;